import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CommonButton from 'app/components/ReviewButton';
import { DATE_RANGE_KEYS } from 'app/constants/filters';
import { encodeURL } from 'app/utils/helpers';
import { useParams } from 'react-router-dom';

type ViewIntelligentTopUpImagesButtonProps = {
  tagId: number;
  useCaseId: number;
  mlModelId: number;
};

export const ViewIntelligentTopUpImagesButton = ({
  tagId,
  useCaseId,
  mlModelId,
}: ViewIntelligentTopUpImagesButtonProps) => {
  const { subscriptionId, packId } = useParams();

  const handleClick = () => {
    const contextualFilters = encodeURL({
      date: DATE_RANGE_KEYS.ALL_DATE_RANGE,
      tags__in: tagId,
      use_case_id__in: useCaseId,
      ml_model_id__in: mlModelId,
    });
    window.open(
      `/${subscriptionId}/${packId}/annotation/review?contextual_filters=${contextualFilters}`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <CommonButton
      text='View images'
      onClick={handleClick}
      variant='tertiary'
      icon={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
    />
  );
};
